// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    color: #031A1C !important;
    /* font-family: "Verdana, Geneva, sans-serif" !important; */
    font-size: 16px !important;
    font-style: normal !important;
}

.label {
    font-size: 16px !important;
    font-weight: 400 !important;
    line-height: 20px !important;
    text-align: left !important;
    margin-top: 20px !important;
    color: #031A1C !important;
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-style: normal;
}

.label span{
    font-size: 14px !important;
}

.primary-btn{
    width: 134px;
    height: 40px;
    flex-shrink: 0;
    color: #fff;
    border-color: none;
    background: linear-gradient(90deg, #B03A6E 0%, #773BC5 51.5%, #2B4DC0 100%);
    border-radius: 10%;
    border: 0;
}

.inputField input{
    width: 92%;
    height: 30%;
    /* flex-shrink: 0; */
    border-radius: 8px;
    /* border: 0.5px solid #2B4DC0; */
    background: #FFF;
    /* border-left: 4px solid red; */
    border-radius: 4px;
    /* border-left: 4px solid red; */
}

.inputRequired  input{
    width: 92%;
    height: 30%;
    border-radius: 8px;
    background: #FFF;
    border-radius: 4px;
    border-left: 2px solid red;
}

.otpField{
    width: 15%;
    height: 47px;
}

.otpField .shrink{
    flex-shrink: 10;
}

.error{
    color: #F00;
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 15px !important;
    font-style: normal;
    /* font-style: italic; */
    font-weight: 300 !important;
    line-height: 20px !important; 
    margin-left: 0px !important;
    text-align: left;
}

/* To remove left margin of error message */
.MuiFormHelperText-root{
    margin-left: 0px !important;
}

.header{
    color: #000;
    font-family: 'Verdana', 'Geneva', 'sans-serif';
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    /* text-transform: capitalize; */
    text-align: left;
}

.typography{
    font-weight: 500 !important;
    line-height: normal !important;
    text-align: left;
    color: #031A1C !important;
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 20px !important;
    margin-top: 37px;
    margin-bottom: 30px;
}

.primary-save-btn{
    display: flex;
    width: 272px;
    height: 48px;
    padding: 11px 40px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 8px;
    background: #D4273C;
    font-size: 16px !important;
}

.secondary-save-btn{
    display: flex;
    width: 272px;
    height: 48px;
    padding: 11px 40px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid #D4273C;
    background: #FFF;
    font-size: 16px !important;
}

/* To remove margin between label of dob and field */
/* .css-a643pv-MuiStack-root > :not(style) ~ :not(style) {
    margin-top: 0 !important;
} */

.title{
    font-weight:600 !important; 
    text-align: 'left' !important; 
    padding: '0px 0px 20px 30px' !important;
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    line-height: 167% !important;
    font-style: normal;
    margin-bottom: 0px !important;
}

.university-name{
    font-weight: 700 !important;
    /* color: #D52B2A !important; */
    font-size: 25px !important;
    color: #578ebe !important;
    text-align: left !important;
    line-height: 120% !important; /* 38.4px */
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
}

.header-subline{
    color: #000 !important;
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 12px !important;
    font-style: normal;
    font-weight: 500 !important;
    line-height: 120% !important; /* 24px */
    letter-spacing: 0.8px !important;
}

.token{
    font-weight: 600;
}

.copy-icon{
    /* margin-left: 10px;  */
    background: transparent; 
    border: none; 
    cursor: pointer;
    vertical-align: sub;
    width: 1%;
    transition: color 0.2s ease-in-out;
}

.copy-icon:hover {
    color: #1976d2; /* No quotes here */
}

.token{
    margin-right: 'auto'; 
    color: '#333';
}

/* To remove arrow of number field */
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button {
    appearance: none;
    margin: 0; 
}

/* To prevent changes on scrolling of number field */
input[type="number"] {
    pointer-events: none;
}

.header-logo-grid{
    padding: 0.3% 1% 0% 1%;
    max-width: 9% !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,2DAA2D;IAC3D,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;IACzB,yDAAyD;IACzD,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,2EAA2E;IAC3E,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,iCAAiC;IACjC,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yDAAyD;IACzD,0BAA0B;IAC1B,kBAAkB;IAClB,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,2CAA2C;AAC3C;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,8CAA8C;IAC9C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,gBAAgB;IAChB,yBAAyB;IACzB,yDAAyD;IACzD,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,oDAAoD;AACpD;;GAEG;;AAEH;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,uCAAuC;IACvC,yDAAyD;IACzD,4BAA4B;IAC5B,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,+BAA+B;IAC/B,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B,EAAE,WAAW;IACzC,yDAAyD;AAC7D;;AAEA;IACI,sBAAsB;IACtB,yDAAyD;IACzD,0BAA0B;IAC1B,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B,EAAE,SAAS;IACvC,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,kCAAkC;AACtC;;AAEA;IACI,cAAc,EAAE,mBAAmB;AACvC;;AAEA;IACI,oBAAoB;IACpB,aAAa;AACjB;;AAEA,oCAAoC;AACpC;;IAII,gBAAgB;IAChB,SAAS;AACb;;AAEA,oDAAoD;AACpD;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B","sourcesContent":["body{\n    color: #031A1C !important;\n    /* font-family: \"Verdana, Geneva, sans-serif\" !important; */\n    font-size: 16px !important;\n    font-style: normal !important;\n}\n\n.label {\n    font-size: 16px !important;\n    font-weight: 400 !important;\n    line-height: 20px !important;\n    text-align: left !important;\n    margin-top: 20px !important;\n    color: #031A1C !important;\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-style: normal;\n}\n\n.label span{\n    font-size: 14px !important;\n}\n\n.primary-btn{\n    width: 134px;\n    height: 40px;\n    flex-shrink: 0;\n    color: #fff;\n    border-color: none;\n    background: linear-gradient(90deg, #B03A6E 0%, #773BC5 51.5%, #2B4DC0 100%);\n    border-radius: 10%;\n    border: 0;\n}\n\n.inputField input{\n    width: 92%;\n    height: 30%;\n    /* flex-shrink: 0; */\n    border-radius: 8px;\n    /* border: 0.5px solid #2B4DC0; */\n    background: #FFF;\n    /* border-left: 4px solid red; */\n    border-radius: 4px;\n    /* border-left: 4px solid red; */\n}\n\n.inputRequired  input{\n    width: 92%;\n    height: 30%;\n    border-radius: 8px;\n    background: #FFF;\n    border-radius: 4px;\n    border-left: 2px solid red;\n}\n\n.otpField{\n    width: 15%;\n    height: 47px;\n}\n\n.otpField .shrink{\n    flex-shrink: 10;\n}\n\n.error{\n    color: #F00;\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 15px !important;\n    font-style: normal;\n    /* font-style: italic; */\n    font-weight: 300 !important;\n    line-height: 20px !important; \n    margin-left: 0px !important;\n    text-align: left;\n}\n\n/* To remove left margin of error message */\n.MuiFormHelperText-root{\n    margin-left: 0px !important;\n}\n\n.header{\n    color: #000;\n    font-family: 'Verdana', 'Geneva', 'sans-serif';\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    /* text-transform: capitalize; */\n    text-align: left;\n}\n\n.typography{\n    font-weight: 500 !important;\n    line-height: normal !important;\n    text-align: left;\n    color: #031A1C !important;\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 20px !important;\n    margin-top: 37px;\n    margin-bottom: 30px;\n}\n\n.primary-save-btn{\n    display: flex;\n    width: 272px;\n    height: 48px;\n    padding: 11px 40px;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0;\n    border-radius: 8px;\n    background: #D4273C;\n    font-size: 16px !important;\n}\n\n.secondary-save-btn{\n    display: flex;\n    width: 272px;\n    height: 48px;\n    padding: 11px 40px;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0;\n    border-radius: 8px;\n    border: 1px solid #D4273C;\n    background: #FFF;\n    font-size: 16px !important;\n}\n\n/* To remove margin between label of dob and field */\n/* .css-a643pv-MuiStack-root > :not(style) ~ :not(style) {\n    margin-top: 0 !important;\n} */\n\n.title{\n    font-weight:600 !important; \n    text-align: 'left' !important; \n    padding: '0px 0px 20px 30px' !important;\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    line-height: 167% !important;\n    font-style: normal;\n    margin-bottom: 0px !important;\n}\n\n.university-name{\n    font-weight: 700 !important;\n    /* color: #D52B2A !important; */\n    font-size: 25px !important;\n    color: #578ebe !important;\n    text-align: left !important;\n    line-height: 120% !important; /* 38.4px */\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n}\n\n.header-subline{\n    color: #000 !important;\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 12px !important;\n    font-style: normal;\n    font-weight: 500 !important;\n    line-height: 120% !important; /* 24px */\n    letter-spacing: 0.8px !important;\n}\n\n.token{\n    font-weight: 600;\n}\n\n.copy-icon{\n    /* margin-left: 10px;  */\n    background: transparent; \n    border: none; \n    cursor: pointer;\n    vertical-align: sub;\n    width: 1%;\n    transition: color 0.2s ease-in-out;\n}\n\n.copy-icon:hover {\n    color: #1976d2; /* No quotes here */\n}\n\n.token{\n    margin-right: 'auto'; \n    color: '#333';\n}\n\n/* To remove arrow of number field */\ninput[type=number]::-webkit-inner-spin-button, \ninput[type=number]::-webkit-outer-spin-button { \n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    margin: 0; \n}\n\n/* To prevent changes on scrolling of number field */\ninput[type=\"number\"] {\n    pointer-events: none;\n}\n\n.header-logo-grid{\n    padding: 0.3% 1% 0% 1%;\n    max-width: 9% !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
